import Axios from "axios";
import { reactLocalStorage } from "reactjs-localstorage";

// export const BASE_URL = "http://35.154.235.57:4040/api/v1/user/";

// export const BASE_URL = "https://api.neoosearch.com/api/v1/user/";
// export const IMAGE_URL = "https://api.neoosearch.com/";

// export const BASE_URL = "http://127.0.0.1:5058/api/v1/user/";
// export const IMAGE_URL = "http://127.0.0.1:5058/";

export const BASE_URL = process.env.REACT_APP_API_URL + '/user/';
export const IMAGE_URL = process.env.REACT_APP_API_URL;


async function requestData(url, method, params = {}) {
  let token = "";
  let user = reactLocalStorage.get("userDataNeoCard");
  if (user && user != null && Object.keys(user).length > 0) {
    token = user;
  }
  let apiUrl = BASE_URL + url;
  var myHeaders = new Headers();
  if (token !== "") {
    myHeaders.append("authorization", token);
  }
  myHeaders.append("userType", "User");
  myHeaders.append("Content-Type", "application/json");
  myHeaders.append("Access-Control-Allow-Origin", "*");
  var raw = JSON.stringify(params);

  var requestOptions = {};
  if (method === "POST") {
    requestOptions = {
      method: method,
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };
  } else if (method === "PUT") {
    requestOptions = {
      method: method,
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };
  } else {
    requestOptions = {
      method: method,
      headers: myHeaders,
      // body: raw,
      redirect: "follow",
    };
  }

  try {
    return await fetch(apiUrl, requestOptions)
      .then((response) => response.json())
      .then((result) => {
        return result;
      })
      .catch((error) => console.log("error", error));
  } catch (error) {
    console.log("error", error)
  }
}

async function fileUplodeDynamic(
  url,
  method,
  file,
  // object_get = {},
  tokenCustom = null
) {
  // let bash_url = "http://142.93.55.214:3089/api/v1/admin/";
  let bash_url = "https://api.fisibility.com/api/v1/user/";

  let apiUrl = bash_url + url;

  let headers = {
    // 'Accept': 'application/json',
    "Content-Type": "multipart/form-data",
    "Access-Control-Allow-Origin": "https://api.fisibility.com",
    // 'Authorization': 'Bearer ' + login_status,
  };

  return await fetch(apiUrl, {
    method: "POST",
    body: file,
    redirect: "follow",
  })
    .then((response) => response.json())
    .then(
      (result) => {
        return result;
      },
      (error) => {
        return error;
      }
    );
}

async function fileUplode(
  url,
  method,
  file,
  object_get = {},
  tokenCustom = null
) {
  let token = "";
  let user = reactLocalStorage.get("userDataNeoCard");
  if (user && user != null && Object.keys(user).length > 0) {
    token = user;
  }
  // let bash_url = "http://13.127.101.102:5011/api/v1/";
  // let apiUrl = "https://api.neoosearch.com/api/v1/" + url;
  // let apiUrl = "http://127.0.0.1:5058/api/v1/" + url;
  let apiUrl = process.env.REACT_APP_API_URL+'/'+ url;
  if (token != "") {
    var toooo = token;
  }
  let headers = {
    // 'Accept': 'application/json',
    // "Content-Type": "multipart/form-data",
    // "Access-Control-Allow-Origin": "http://13.127.101.102:5008",
    authorization: toooo,
    userType: "User",
    // 'Authorization': 'Bearer ' + login_status,
  };


  return await fetch(apiUrl, {
    method: method,
    body: file,
    redirect: "follow",
    headers: headers,
  })
    .then((response) => {
      return response.json();
    })
    .then(
      (result) => {
        return result;
      },
      (error) => {
        return error;
      }
    );
}

async function newFileUpload(url, file, object_get) {
  // let bash_url = "http://127.0.0.1:3030/api/";
  let bash_url = "https://api.fisibility.com/api/v1/";

  let apiUrl = bash_url + url;

  const data = new FormData();
  if (typeof file == "string") {
    data.append("image", {
      uri: String(file),
      type: "image/jpeg",
      name: "filename.jpg",
    });
  } else {
    data.append("image", file);
  }

  Object.keys(object_get).forEach(function (key) {
    let ddd = object_get[key];
    data.append(key, ddd);
  });

  var requestOptions = {
    method: "POST",
    body: data,
    redirect: "follow",
  };

  return await fetch(apiUrl, requestOptions)
    .then((response) => response.json())
    .then((result) => {
      return result;
    })
    .catch((error) => {
      return error;
    });
}

async function newFileCropUpload(url, file, object_get) {
  let bash_url = "https://api.fisibility.com/api/";
  // let bash_url = "http://127.0.0.1:3030/api/";

  let apiUrl = bash_url + url;

  const data = new FormData();
  data.append("image", {
    uri: file,
    type: "image/jpeg",
    name: "filename.jpg",
  });

  var requestOptions = {
    method: "POST",
    body: data,
    redirect: "follow",
  };

  return await fetch(apiUrl, requestOptions)
    .then((response) => response.json())
    .then((result) => {
      return result;
    })
    .catch((error) => {
      return error;
    });
}

async function videoUpload(url, file, object_get) {
  let bash_url = "https://api.fisibility.com/api/";

  let apiUrl = bash_url + url;
  const data = new FormData();
  // // data.append("video", fileInput.files[0], "Mumbai ka secret haath laga _ RCB vs RR _ Pre match chat.mp4");
  data.append("video", file);

  var requestOptions = {
    method: "POST",
    body: data,
    redirect: "follow",
  };

  return await fetch(apiUrl, requestOptions)
    .then((response) => response.json())
    .then((result) => {
      return result;
    })
    .catch((error) => {
      return error;
    });
}

async function uploadFileRequest(url, file, callback) {
  const BASE_URL = "https://api.fisibility.com/api/";
  var cancelToken = Axios.CancelToken;
  var source = cancelToken.source();
  let apiUrl = BASE_URL + url;

  const data = new FormData();
  data.append("video", file);

  let config = {
    headers: {
      Accept: "application/json",
      "Content-Type": "multipart/form-data",
    },
    onUploadProgress: (progressEvent) => {
      var percentCompleted = Math.round(
        (progressEvent.loaded * 100) / progressEvent.total
      );
      callback(percentCompleted, null, null);
    },
    cancelToken: source.token,
  };

  return await Axios.post(apiUrl, data, config)
    .then((res) => {
      return res.data;
    })
    .catch((error) => {
      callback(null, null, error);
    });
}

const getOriginalname = async (data, extn) => {
  let arr = data.split("/");
  let lent = Number(arr.length - 1);
  if (!arr[lent].match(/.(jpg|jpeg|png|gif|pdf|csv|plainText|zip)$/i)) {
    return arr[lent] + "." + extn.substring(extn.lastIndexOf("/") + 1);
  } else {
    return arr[lent];
  }
};

async function OcrFileUplode(
  url = "POST",
  method,
  file,
  object_get = {},
  tokenCustom = null
) {
  let token = "";
  let user = reactLocalStorage.getObject("userData");
  // if (user && user != null && Object.keys(user).length > 0) {
  //   token = user.token;
  // }
  // let bash_url = "http://13.127.101.102:5011/api/v1/";
  let apiUrl = "https://api.fisibility.com/api/v1/receipt";

  if (token != "") {
    var toooo = token;
  }
  let headers = {
    // 'Accept': 'application/json',
    // "Content-Type": "multipart/form-data",
    // "Access-Control-Allow-Origin": "http://13.127.101.102:5008",
    authorization: toooo,
    userType: "User",
    // 'Authorization': 'Bearer ' + login_status,
  };

  return await fetch(apiUrl, {
    method: method,
    body: file,
    redirect: "follow",
    headers: headers,
  })
    .then((response) => {
      return response.json();
    })
    .then(
      (result) => {
        return result;
      },
      (error) => {
        return error;
      }
    );
}

async function _fileUploadWithoutAuth(url, file, object_get) {
  // let bash_url = "http://127.0.0.1:3030/api/";
  // let bash_url = "https://api.fisibility.com/api/v1/";
  // let bash_url = "http://127.0.0.1:5058/api/v1";
  let bash_url = process.env.REACT_APP_API_URL;

  let apiUrl = bash_url + url;

  const data = new FormData();
  if (typeof file == "string") {
    data.append("image", {
      uri: String(file),
      type: "image/jpeg",
      name: "filename.jpg",
    });
  } else {
    data.append("image", file);
  }

  Object.keys(object_get).forEach(function (key) {
    let ddd = object_get[key];
    data.append(key, ddd);
  });

  var requestOptions = {
    method: "POST",
    body: data,
    redirect: "follow",
  };

  return await fetch(apiUrl, requestOptions)
    .then((response) => response.json())
    .then((result) => {
      return result;
    })
    .catch((error) => {
      return error;
    });
}

async function fileUploadWithoutAuth(
  url,
  method,
  file,
  object_get = {},
  tokenCustom = null
) {
  let token = "";
  let user = reactLocalStorage.get("userDataNeoCard");
  if (user && user != null && Object.keys(user).length > 0) {
    token = user;
  }
  // let bash_url = "http://13.127.101.102:5011/api/v1/";
  // let apiUrl = "https://api.neoosearch.com/api/v1/admin/" + url;
  // let apiUrl = "https://api.neoosearch.com/api/v1/" + url;
  // let apiUrl = "http://127.0.0.1:5058/api/v1/" + url;
  let apiUrl = process.env.REACT_APP_API_URL+'/'+ url;

  if (token != "") {
    var toooo = token;
  }
  let headers = {

  };


  return await fetch(apiUrl, {
    method: method,
    body: file,
    redirect: "follow",
    headers: headers,
  })
    .then((response) => {
      return response.json();
    })
    .then(
      (result) => {
        return result;
      },
      (error) => {
        return error;
      }
    );
}

export default {
  requestData,
  fileUplode,
  newFileUpload,
  newFileCropUpload,
  videoUpload,
  uploadFileRequest,
  fileUplodeDynamic,
  fileUploadWithoutAuth,
  // get,
  // post,
  // put,
  // // delete,
  // upload,
};
